'use client';

import { c as _c } from "react/compiler-runtime";
import { pipe } from 'effect';
import { useAtom, useAtomValue } from 'jotai';
import { baseVocabAtom, irregularWordsQueryAtom } from '@/app/[locale]/(vocabulary)/_api';
import { VocabDataTable } from '@/app/[locale]/(vocabulary)/_components/data';
import { LexiconTrie } from '@/app/[locale]/(vocabulary)/_lib/LexiconTrie';
import { NoSSR } from '@/components/NoSsr';
import { tap } from '@sub-vocab/utils/lib';
export default function VocabularyPage() {
  const $ = _c(9);
  const [userWords] = useAtom(baseVocabAtom);
  const {
    data: t0
  } = useAtomValue(irregularWordsQueryAtom);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? [] : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const irregulars = t1;
  let t2;
  if ($[2] !== irregulars || $[3] !== userWords) {
    let t3;
    if ($[5] !== userWords) {
      t3 = x => {
        x.input(userWords.map(_temp));
      };
      $[5] = userWords;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = pipe(new LexiconTrie(), tap(t3), x_0 => x_0.generate(irregulars, userWords));
    $[2] = irregulars;
    $[3] = userWords;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const list = t2;
  let t3;
  if ($[7] !== list) {
    t3 = <NoSSR><VocabDataTable data={list} className="size-full md:mx-0 md:grow" /></NoSSR>;
    $[7] = list;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
function _temp(w) {
  return w.form;
}